/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Home.scss';

class Home extends React.Component {
    render() {
        return (
            <div className={s.container}>
                <div className={s.loginBlock}>
                    <div className={s.description}>
                        <strong>EnvatoStats</strong>
                        {' '}
is statistics and collaboration helper application for Envato authors. It will help you calculate how much you earn and how much you need to pay to your partners.
                    </div>
                    <a className={s.envatoBtn} href="/login/envato/">Sign in with Envato</a>
                </div>
            </div>
        );
    }
}

export default withStyles(s)(Home);
